import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import { drawerBackdropBlurStyle } from '../../shared/style-settings'

export const eulaDialogBackdropStyle = drawerBackdropBlurStyle

export const useEulaAgreementDialogStyles = makeStyles((theme: Theme) =>
  createStyles({
    dialogPaper: {
      borderRadius: theme.shape.borderRadius * 2,
      maxWidth: 560,
    },
    dialogTitle: {
      position: 'relative',
      padding: theme.spacing(3, 3, 1),
      '& h2': {
        fontWeight: 700,
        fontSize: '1.375rem',
        lineHeight: 1.3,
        paddingRight: theme.spacing(4),
      },
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
    subtitle: {
      padding: theme.spacing(0, 3, 2),
      color: theme.palette.text.secondary,
      fontSize: '0.9375rem',
      lineHeight: 1.5,
    },
    scrollPanel: {
      margin: theme.spacing(0, 3),
      padding: theme.spacing(2),
      maxHeight: 280,
      overflowY: 'auto',
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: theme.shape.borderRadius * 2,
      backgroundColor: theme.palette.background.paper,
    },
    section: {
      '& + &': {
        marginTop: theme.spacing(2),
      },
    },
    sectionTitle: {
      fontWeight: 700,
      fontSize: '0.9375rem',
      marginBottom: theme.spacing(0.75),
      color: theme.palette.text.primary,
    },
    sectionBody: {
      margin: 0,
      fontSize: '0.875rem',
      lineHeight: 1.6,
      color: theme.palette.text.secondary,
    },
    acceptNote: {
      margin: theme.spacing(2, 3, 0),
      fontSize: '0.8125rem',
      lineHeight: 1.5,
      color: theme.palette.text.secondary,
    },
    actions: {
      padding: theme.spacing(2, 3, 3),
      justifyContent: 'space-between',
      gap: theme.spacing(1.5),
    },
    rejectButton: {
      minWidth: 120,
      textTransform: 'none',
      fontWeight: 600,
    },
    acceptButton: {
      minWidth: 120,
      textTransform: 'none',
      fontWeight: 600,
    },
  })
)
